<dialog
  class="fixed bottom-4 z-50 mx-10 min-w-96 rounded-lg bg-white p-6 text-sm shadow-[0px_6px_12px_-3px_rgba(0,0,0,0.3)]"
  #dialog
>
  <button class="absolute top-4 right-4 p-2 text-lg" (click)="close()">
    X
  </button>
  <div class="" [innerHTML]="'components.welcomeDialog.text' | translate"></div>
  <div class="mt-4 flex">
    <button class="btn-primary btn text-sm" (click)="goToAccountCreation()">
      {{ 'components.welcomeDialog.createAccount' | translate }}
    </button>
    <button class="btn-secondary ml-auto btn text-sm" (click)="close()">
      {{ 'components.welcomeDialog.close' | translate }}
    </button>
  </div>
</dialog>
